var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectListSorted',{attrs:{"facet":_vm.$options.config.facet,"order":"alphabetical"},scopedSlots:_vm._u([{key:"icon",fn:function(ref){
var value = ref.value;
return [_c('img',{attrs:{"src":_vm.logo(value),"alt":value,"width":"24"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }